import axios from "axios";
import { shallowRef, watch } from "vue";
import { APIResponse, CompanyDto } from "../api-contract/api-contract";
import { appLanguageSwitcherModel } from "../components/app-language-switcher/app-language-switcher.model";
import { sessionModel } from "@/shared/state/session.model";
import { currentUserModel } from "./current-user.model";

export class CurrentCompanyModel {
    companyDto = shallowRef<CompanyDto | undefined>();

    constructor() {
        watch(
            () => ({
                lang: appLanguageSwitcherModel.lang.value,
                accessToken: sessionModel.sessionDto.value
                    ? sessionModel.sessionDto.value.token
                    : "",
                currentUser: sessionModel.JWTUserDto.value,
            }),
            async ({ accessToken, lang, currentUser }) => {
                if (!accessToken || !currentUser?.id_customer) {
                    return;
                }
                axios
                    .get<APIResponse<CompanyDto>>("/client/web/company", {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            "Accept-Language": lang,
                        },
                    })
                    .then((apiResponse) => {
                        if (
                            apiResponse.status !== 200 ||
                            apiResponse.data.status.code !== 200
                        ) {
                            return undefined;
                        }
                        this.companyDto.value = apiResponse.data.data;
                    })
                    .catch(console.log);
            },
            { immediate: true },
        );
    }
}

export const currentCompanyModel = new CurrentCompanyModel();
